// Whether this load carries an authentication response. MSAL marks one with
// a `state` parameter in either the hash or the query.
function hasAuthResponse() {
  const hash = window.location.hash.replace(/^#/, '');
  const query = window.location.search.replace(/^\?/, '');

  return new URLSearchParams(hash).has('state') || new URLSearchParams(query).has('state');
}

// A silent token renewal loads the redirect URI in a hidden iframe, which
// would boot the whole SPA in there and have MSAL refuse it with
// `block_iframe_reload`. The bridge posts the response back to the frame
// waiting on it and closes the iframe instead.
//
// A full-page sign-in redirect has the app to come back to, so it is not the
// bridge's to answer. Each branch imports only what it takes, so an auth
// frame does not evaluate the whole app to then not mount it.
if (window.parent !== window && hasAuthResponse()) {
  const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge');

  await broadcastResponseToMainFrame();
} else {
  const { bootApp } = await import('./bootApp');

  await bootApp();
}
